import Dashboard from "../pages/admin/Dashboard";
import BookingsList from "../pages/admin/bookings/List";
import BookingDetails from "../pages/admin/bookings/Details";
import CategoryList from "../pages/admin/categories/List";
import AddCategory from "../pages/admin/categories/AddUpdate";
import partnerList from "../pages/admin/partners/List";
import Addpartner from "../pages/admin/partners/AddUpdate";
import partnerDetails from "../pages/admin/partners/Details";
import ServiceForm from "../pages/admin/partners/services/AddUpdate";
import BannerList from "../pages/admin/banners/List";
import AddBanner from "../pages/admin/banners/AddUpdate";
import NotificationsList from "../pages/admin/notifications/List";
import SystemUserList from "../pages/admin/system_users/List";
import AddSystemUser from "../pages/admin/system_users/AddUpdate";
import RoleList from "../pages/admin/roles/List";
import AddRole from "../pages/admin/roles/AddUpdate";
import PromoCodeList from "../pages/admin/promo_codes/List";
import AddPromoCode from "../pages/admin/promo_codes/AddUpdate";
import BusinessTypeList from "../pages/admin/business_types/List";
import BusinessTypeForm from "../pages/admin/business_types/AddUpdate";
import Account from "../pages/admin/Account";
import UserList from "../pages/admin/users/List";
import CustomerDetails from "../pages/admin/users/CustomerDetails";
import Setting from "../pages/admin/Setting";
import TermsConditions from "../pages/admin/TermsConditions";
import PrivacyPolicy from "../pages/admin/PrivacyPolicy";
import PayoutList from "../pages/admin/payouts/List";
import PayoutHistory from "../pages/admin/payouts/History";
import ContactQueriesList from "../pages/admin/contact_queries/List";

const adminRoutes = [
  {
    path: "/admin/dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },

  // Bookings
  {
    path: "/admin/bookings",
    component: BookingsList,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/bookings/:id",
    component: BookingDetails,
    meta: { requiresAuth: true },
  },

  // partner Management
  {
    path: "/admin/partners",
    component: partnerList,
    meta: { requiresAuth: true, permission: "list-partners" },
  },
  {
    path: "/admin/partners/create/:id?",
    component: Addpartner,
    meta: { requiresAuth: true, permission: "create-partners" },
  },
  {
    path: "/admin/partners/:id",
    component: partnerDetails,
    meta: { requiresAuth: true, permission: "list-partners" },
  },
  {
    path: "/admin/partners/:partnerId/services/create/:id?",
    component: ServiceForm,
    meta: { requiresAuth: true },
  },

  // User Management
  {
    path: "/admin/users",
    component: UserList,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/users/:id",
    component: CustomerDetails,
    meta: { requiresAuth: true },
  },

  // Notifications
  {
    path: "/admin/notifications",
    component: NotificationsList,
    meta: { requiresAuth: true },
  },

  // Contact Queries
  {
    path: "/admin/contact-queries",
    component: ContactQueriesList,
    meta: { requiresAuth: true },
  },

  // Data Management
  {
    path: "/admin/banners",
    component: BannerList,
    meta: { requiresAuth: true, permission: "list-banners" },
  },
  {
    path: "/admin/banners/create/:id?",
    component: AddBanner,
    meta: { requiresAuth: true, permission: "create-banners" },
  },
  {
    path: "/admin/categories",
    component: CategoryList,
    meta: { requiresAuth: true, permission: "list-categories" },
  },
  {
    path: "/admin/categories/create/:id?",
    component: AddCategory,
    meta: { requiresAuth: true, permission: "create-categories" },
  },
  {
    path: "/admin/promo-codes",
    component: PromoCodeList,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/promo-codes/create/:id?",
    component: AddPromoCode,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/business-types",
    component: BusinessTypeList,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/business-types/create/:id?",
    component: BusinessTypeForm,
    meta: { requiresAuth: true },
  },

  // Team Management
  {
    path: "/admin/system-users",
    component: SystemUserList,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/system-users/create/:id?",
    component: AddSystemUser,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/roles",
    component: RoleList,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/roles/create/:id?",
    component: AddRole,
    meta: { requiresAuth: true },
  },

  // Partner Payouts
  {
    path: "/admin/payouts",
    component: PayoutList,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/payouts/history",
    component: PayoutHistory,
    meta: { requiresAuth: true },
  },

  // System Configuration
  {
    path: "/admin/settings",
    component: Setting,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/terms-conditions",
    component: TermsConditions,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/privacy-policy",
    component: PrivacyPolicy,
    meta: { requiresAuth: true },
  },

  // Account
  {
    path: "/admin/account",
    component: Account,
    meta: { requiresAuth: true },
  },
];

export default adminRoutes;
